import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { ForgotPasswordFormDataService } from "common/services/data-services/admin/login/forgot-password/forgotpassword-form-data.service";
import { ForgotPasswordModel } from "common/models/page-models/Login/forgot-password/forgot-password-data-model";
import { ForgotPasswordMetaModel } from "common/models/page-models/Login/forgot-password/forgot-password-form-meta-model";



@Injectable({
    providedIn: 'root'
})
export class ForgotPasswordFormWidgetService extends FormWidgetService<ForgotPasswordModel> {
    constructor(protected ds: ForgotPasswordFormDataService) {
        super(ds);
    }



    getMetaModel(): MetaModel {
        const meta = new ForgotPasswordMetaModel();
        return meta.getMetaModel();
    }
}
